import { createNavigationContainerRef } from "@react-navigation/native";
import { RootStackParamList } from "./RootNavigation";

export const navigationRef = createNavigationContainerRef<RootStackParamList>();
